import Vue from 'vue'

export var bus = new Vue({
    methods: {
        GetUsersByType(response){
            this.$emit('GetUsersByType',response)
        },
        Show_Modal() {
            this.$emit('ShowModal')
        },
        GetAllUser(users,value) {
            this.$emit('AllUser', users,value)
        },
        GetAllUserVal(users){
            this.$emit('GetAllUserVal', users)
        },
        GetAllTypeUser(user_type) {
            this.$emit('AllTypeUser', user_type)
        },
        GetAllTypeClient(client_type){
            this.$emit('AllTypeClient', client_type)
        },
        GetEditUser(user){
            this.$emit('GetEditUser',user)
        },
        ResponseCreateUser(response){
            this.$emit('ResponseCreateUser',response)
        }
        ,
        ResponseUpdateUser(response){
            this.$emit('ResponseUpdateUser',response)
        },
        GetValdateMail(response){
            this.$emit('GetValdateMail',response)
        },
        GetValdateUser(response){
            this.$emit('GetValdateUser',response)
        },
        GetAllRestaurant(data){
            this.$emit('GetAllRestaurant',data)
        },
        GetAllUserPagination(response) {
            this.$emit('GetAllUserPagination', response)
        },
        GetAllCity(response){
            this.$emit('GetAllCity',response)
        },
        GetAllDiscounts(response){
            this.$emit('GetAllDiscounts',response)
        },
        GetAllDealer(response){
            this.$emit('GetAllDealer', response)
        },
        DeleteUser(response){
            this.$emit('DeleteUser', response)
        },
        Getdata(){
            this.$emit('Getdata')
        }
    }
});
